export const ADMIN_EMAILS = ["admin@cinesis.ai"];

export function isAdmin(user) {
  if (!user || !user.email) return false;
  return ADMIN_EMAILS.includes(user.email.toLowerCase());
}
